import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery, themeColor } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { JoykitIcon } from '@components/JoykitIcon';

export const StyledSection = styled(Box)`
  height: 96vh;
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    height: 85vh;
  }
  ${themeMediaQuery('sm')} {
    min-height: var(--hero-min-height);
  }
`;

export const HeroVideoContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroBodymovinWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const VideoOverlay = styled(Flex)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 3;
  background: linear-gradient(180deg, #000000 -10.98%, rgba(0, 0, 0, 0) 31.37%),
    linear-gradient(180deg, rgba(0, 0, 0, 0) 54.7%, rgba(0, 0, 0, 0.45) 80.73%, rgba(0, 0, 0, 0.6) 100%),
    linear-gradient(180deg, rgba(0, 0, 0, 0) 38.54%, #000000 100%);
`;

export const HeroTextPairing = styled(TextPairing)`
  .text-pairing-title {
    margin-bottom: ${themeSpace(3)};
  }

  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 300px;
    }
    .text-pairing-body {
      padding-left: ${themeSpace(6)};
      padding-right: ${themeSpace(6)};
    }
  }
`;

export const HeroTextColumns = styled(Columns)`
  position: relative;
  height: 100%;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const HeroTextColumn = styled(Columns.Column)`
  height: 100%;
`;

export const ButtonsContainer = styled(Flex)`
  justify-content: center;
  gap: ${themeSpace(5)};
  ${themeMediaQuery('sm')} {
    gap: ${themeSpace(6)};
  }
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    align-items: center;
    gap: ${themeSpace(6)};
  }
`;

export const PlayIcon = styled(JoykitIcon)`
  height: auto;
  display: inline-flex;
  vertical-align: sub;
  margin-right: ${themeSpace(3)};
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(6)};
    height: 48px;
    line-height: 46px;
  }
  &:hover ${PlayIcon} svg {
    color: ${themeColor('linkHover')};
  }
  &:active ${PlayIcon} svg {
    color: ${themeColor('linkPress')};
  }
`;
